<script>
    import { onMount, onDestroy } from 'svelte';
    import SettingsAnalyzeInfo from "../components/SettingsAnalyzeInfo.svelte";
    import {applyPromo, changeUserInfo, changeAutoRegInfo} from "../lib/ApiRequests.svelte";
    import LoadingIcon from "../components/LoadingIcon.svelte";
    import {_} from '../lib/i18n';
    import SettingsHandlerInfo from "../components/SettingsHandlerInfo.svelte";

    export let params = {};
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    let email = (params && params.identity) ? params.identity.email : null;
    //$: email = (params && params.identity) ? params.identity.email : null;

    //let newEmail = (params && params.identity) ? params.identity.email : null;

    export let identity = {};
    let isTemporaryEmail = (identity) ? identity.is_temporary_email : false;
    //$: isTemporaryEmail = (identity) ? identity.is_temporary_email : false;
    let isTemporaryPassword;
    $: isTemporaryPassword = (identity) ? identity.is_temporary_password : false;

    export let analyzes = [];

    let handlers = getHandlers(analyzes);

    let refreshInterval;
    onMount(() => {
        //window.scrollTo(0, 0);

        try {
            if (params && params.setState instanceof Function) {
                params.setState({
                    pageTitle: $_('settings.pageTitle'),
                    pageTitleTag: $_('settings.pageTitleTag'),
                });
            }
        } catch (err) {
            console.error(err);
        }

    });

    onDestroy(() => {

    });

    function getHandlers(analyzes) {
        let handlers = [];
        let handlersLogin = [];
        let analyzesWithHandlers = analyzes.filter((analyze) => {return analyze.handler !== null})
        analyzesWithHandlers.forEach(function (analyze) {
            if (analyze.handler && !handlersLogin.includes(analyze.handler.login)) {
                handlers.push(analyze.handler);
                handlersLogin.push(analyze.handler.login);
            }
        })
        return handlers;
    }

    function calcDeletionDate(startedAt) {
        if (!startedAt) return (new Date());

        const tmp = new Date(startedAt.getTime() + 86400 * 1000 * 7);
        console.log(startedAt);
        console.log(tmp);
        //tmp.setMonth(startedAt.getMonth() + 1);
        //tmp.setDate(startedAt.getDate() + 7);
        return tmp;
    }

    function isDeletable(analyze) {
        if (analyze.temporary) return true;

        const analyzeStartedAt = (analyze && analyze.date_start_epoch) ? new Date(analyze.date_start_epoch * 1000) : new Date();
        if (calcDeletionDate(analyzeStartedAt) < (new Date())) {
            return true;
        }

        return false;
    }

    let promoInProgress = false;
    let code = '';
    let promoError = '';
    let promoSuccess = false;
    let promoSuccessMsg = '';

    function applyPromoResults(response) {
        let message = $_('settings.promoCodeSuccessMsg');
        if (response.activation && response.activation.discount && response.activation.message_new) {
            message = response.activation.message_new.replace('{value}', response.activation.discount);
            identity.addDiscount(response.activation);
        }

        return message;
    }
    async function initApplyPromo() {
        promoInProgress = true;
        promoError = '';
        promoSuccessMsg = '';
        try {
            const response = await applyPromo(code);
            switch (response.status) {
                case 'ok':
                    promoSuccess = true;
                    promoSuccessMsg = applyPromoResults(response);
                    break;
                case 'error':
                    promoSuccess = false;
                    promoError = response.text;
                    break;
            }
        } catch (err) {
            console.error(err);
        }
        promoInProgress = false;
    }


    let showModal = false;
    let oldPassword = '';
    let newPassword = '';
    let newPasswordRepeat = '';
    let showOldPassword = false;
    let showNewPassword = false;
    let showNewPasswordRepeat = false;

    let changeInfoError = '';
    let changeInfoLoading = false;

    let changeInfoSuccess = false;

    async function initChangeUserInfo() {
        changeInfoLoading = true;
        changeInfoError = '';
        changeInfoSuccess = false;

        if (isTemporaryPassword) {
            if (newPassword !== newPasswordRepeat) {
                changeInfoLoading = false;
                changeInfoError = $_('settings.passwordsNotEqualError');
                return;
            }
            const changeTempPasswordResponse = await changeAutoRegInfo(email, newPassword, newPasswordRepeat);
            if (changeTempPasswordResponse.status === 'error') {
                changeInfoError = changeTempPasswordResponse.message;
            } else {
                changeInfoSuccess = true;
                newPassword = '';
                newPasswordRepeat = '';
                try {
                    console.log('Changing temporary user credentials');
                    if (params && params.changeTemporaryPassword instanceof Function) {
                        params.changeTemporaryPassword();
                        params.identity.changeKeyValue('is_temporary_password', false);
                        isTemporaryPassword = false;
                    }
                    if (params && params.changeTemporaryEmail instanceof Function) {
                        params.changeTemporaryEmail(email);
                        isTemporaryEmail = false;
                    }
                } catch (err) { console.error(err) }
            }
        } else {
            if (!oldPassword) {
                changeInfoLoading = false;
                changeInfoError = $_('settings.oldPasswordNotEnteredError');
                return;
            }

            if (!newPassword) {
                changeInfoLoading = false;
                changeInfoError = $_('settings.newPasswordNotEnteredError');
                return;
            }

            if (oldPassword.length < 6) {
                changeInfoLoading = false;
                changeInfoError = $_('settings.tooShortOldPasswordError');
                return;
            }

            if (newPassword.length < 6) {
                changeInfoLoading = false;
                changeInfoError = $_('settings.tooShortNewPasswordError');
                return;
            }

            const changeUserInfoResponse = await changeUserInfo(email, oldPassword, newPassword);
            if (changeUserInfoResponse.status === 'error') {
                changeInfoError = changeUserInfoResponse.message;
            } else {
                changeInfoSuccess = true;
            }
        }

        changeInfoLoading = false;
    }
</script>

<div class="canvas__col canvas__col_left">
    <section class="account-settings">
        <h4 class="account-settings__title">{$_('settings.accountSettingsTitle')}</h4>

        <form action="" class="account-settings__form" on:submit|preventDefault={initChangeUserInfo}>
            <label for="user-email" class="account-settings__form-label">E-mail</label>

            <input id="user-email" type="email"
                   class={`${isTemporaryEmail ? 'error' : ''} general-input account-settings__form-email-input`}
                   bind:value="{email}" disabled={!isTemporaryEmail}
            />

            <label class="account-settings__form-label">{$_('settings.changePasswordLabel')}</label>

            {#if !isTemporaryPassword}
            <div class="account-settings__form-password">
							<span on:click={() => {showOldPassword = !showOldPassword}} class={`account-settings__form-password-icon invisible`}>
								<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M2.05667 9.59073L1.36262 9.87499L2.05667 9.59073ZM2.75072 8.69352C3.75892 6.23184 6.1781 4.5 9 4.5V3C5.54839 3 2.59359 5.11944 1.36262 8.12501L2.75072 8.69352ZM9 4.5C11.8219 4.5 14.2411 6.23185 15.2493 8.69352L16.6374 8.12502C15.4064 5.11944 12.4516 3 9 3V4.5ZM15.2493 9.30648C14.2411 11.7682 11.8219 13.5 9 13.5V15C12.4516 15 15.4064 12.8806 16.6374 9.87499L15.2493 9.30648ZM9 13.5C6.1781 13.5 3.75892 11.7682 2.75071 9.30648L1.36262 9.87499C2.59358 12.8806 5.54839 15 9 15V13.5ZM15.2493 8.69352C15.3297 8.88978 15.3297 9.11022 15.2493 9.30648L16.6374 9.87499C16.867 9.31441 16.867 8.6856 16.6374 8.12502L15.2493 8.69352ZM1.36262 8.12501C1.13303 8.68559 1.13303 9.31441 1.36262 9.87499L2.75071 9.30648C2.67033 9.11022 2.67033 8.88978 2.75072 8.69352L1.36262 8.12501Z" fill="black" />
									<circle cx="9" cy="9" r="2.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							</span>
                <span on:click={() => {showOldPassword = !showOldPassword}} class={`account-settings__form-password-icon ${showOldPassword ? '' : 'visible'}`}>
								<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M3 3L15 15" stroke="black" stroke-width="2" stroke-linecap="round" />
									<path fill-rule="evenodd" clip-rule="evenodd" d="M4.45176 4.36597C3.07891 5.27491 1.99401 6.58339 1.36262 8.12501C1.13303 8.68559 1.13303 9.31441 1.36262 9.87499C2.59358 12.8806 5.54839 15 9 15C10.7255 15 12.3269 14.4703 13.6508 13.565L12.5673 12.4815C11.532 13.1271 10.3094 13.5 9 13.5C6.1781 13.5 3.75892 11.7682 2.75071 9.30648C2.67033 9.11022 2.67033 8.88978 2.75071 8.69352C3.30705 7.33514 4.29303 6.19899 5.53922 5.45344L4.45176 4.36597ZM6.922 6.83622C6.35371 7.38212 6 8.14975 6 9C6 10.6569 7.34315 12 9 12C9.85025 12 10.6179 11.6463 11.1638 11.078L10.1027 10.0169C9.82862 10.314 9.43604 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.56396 7.68605 8.17138 7.9831 7.89731L6.922 6.83622ZM11.9988 9.08462L8.91538 6.00117C8.94349 6.00039 8.9717 6 9 6C10.6569 6 12 7.34315 12 9C12 9.0283 11.9996 9.05651 11.9988 9.08462ZM14.0937 11.1795C14.5746 10.6269 14.9672 9.99527 15.2493 9.30648C15.3297 9.11022 15.3297 8.88978 15.2493 8.69352C14.2411 6.23185 11.8219 4.5 9 4.5C8.50822 4.5 8.02868 4.5526 7.5667 4.65249L6.34928 3.43507C7.18113 3.153 8.07263 3 9 3C12.4516 3 15.4064 5.11944 16.6374 8.12502C16.867 8.6856 16.867 9.31441 16.6374 9.87499C16.2794 10.7491 15.7756 11.5482 15.1562 12.242L14.0937 11.1795Z" fill="black" />
								</svg>
							</span>
                {#if showOldPassword}
                    <input bind:value={oldPassword} type="text" class="general-input account-settings__form-password-input" placeholder={$_('settings.oldPasswordPlaceholder')} />
                {:else}
                    <input bind:value={oldPassword} type="password" class="general-input account-settings__form-password-input" placeholder={$_('settings.oldPasswordPlaceholder')} />
                {/if}
            </div>
            {/if}

            <div class="account-settings__form-password">
							<span on:click={() => {showNewPassword = !showNewPassword}} class={`account-settings__form-password-icon invisible`}>
								<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M2.05667 9.59073L1.36262 9.87499L2.05667 9.59073ZM2.75072 8.69352C3.75892 6.23184 6.1781 4.5 9 4.5V3C5.54839 3 2.59359 5.11944 1.36262 8.12501L2.75072 8.69352ZM9 4.5C11.8219 4.5 14.2411 6.23185 15.2493 8.69352L16.6374 8.12502C15.4064 5.11944 12.4516 3 9 3V4.5ZM15.2493 9.30648C14.2411 11.7682 11.8219 13.5 9 13.5V15C12.4516 15 15.4064 12.8806 16.6374 9.87499L15.2493 9.30648ZM9 13.5C6.1781 13.5 3.75892 11.7682 2.75071 9.30648L1.36262 9.87499C2.59358 12.8806 5.54839 15 9 15V13.5ZM15.2493 8.69352C15.3297 8.88978 15.3297 9.11022 15.2493 9.30648L16.6374 9.87499C16.867 9.31441 16.867 8.6856 16.6374 8.12502L15.2493 8.69352ZM1.36262 8.12501C1.13303 8.68559 1.13303 9.31441 1.36262 9.87499L2.75071 9.30648C2.67033 9.11022 2.67033 8.88978 2.75072 8.69352L1.36262 8.12501Z" fill="black" />
									<circle cx="9" cy="9" r="2.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							</span>
                <span on:click={() => {showNewPassword = !showNewPassword}} class={`account-settings__form-password-icon ${showNewPassword ? '' : 'visible'}`}>
								<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M3 3L15 15" stroke="black" stroke-width="2" stroke-linecap="round" />
									<path fill-rule="evenodd" clip-rule="evenodd" d="M4.45176 4.36597C3.07891 5.27491 1.99401 6.58339 1.36262 8.12501C1.13303 8.68559 1.13303 9.31441 1.36262 9.87499C2.59358 12.8806 5.54839 15 9 15C10.7255 15 12.3269 14.4703 13.6508 13.565L12.5673 12.4815C11.532 13.1271 10.3094 13.5 9 13.5C6.1781 13.5 3.75892 11.7682 2.75071 9.30648C2.67033 9.11022 2.67033 8.88978 2.75071 8.69352C3.30705 7.33514 4.29303 6.19899 5.53922 5.45344L4.45176 4.36597ZM6.922 6.83622C6.35371 7.38212 6 8.14975 6 9C6 10.6569 7.34315 12 9 12C9.85025 12 10.6179 11.6463 11.1638 11.078L10.1027 10.0169C9.82862 10.314 9.43604 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.56396 7.68605 8.17138 7.9831 7.89731L6.922 6.83622ZM11.9988 9.08462L8.91538 6.00117C8.94349 6.00039 8.9717 6 9 6C10.6569 6 12 7.34315 12 9C12 9.0283 11.9996 9.05651 11.9988 9.08462ZM14.0937 11.1795C14.5746 10.6269 14.9672 9.99527 15.2493 9.30648C15.3297 9.11022 15.3297 8.88978 15.2493 8.69352C14.2411 6.23185 11.8219 4.5 9 4.5C8.50822 4.5 8.02868 4.5526 7.5667 4.65249L6.34928 3.43507C7.18113 3.153 8.07263 3 9 3C12.4516 3 15.4064 5.11944 16.6374 8.12502C16.867 8.6856 16.867 9.31441 16.6374 9.87499C16.2794 10.7491 15.7756 11.5482 15.1562 12.242L14.0937 11.1795Z" fill="black" />
								</svg>
							</span>
                {#if showNewPassword}
                    <input bind:value={newPassword} type="text" class="general-input account-settings__form-password-input" placeholder={$_('settings.newPasswordPlaceholder')} />
                {:else}
                    <input bind:value={newPassword} type="password" class="general-input account-settings__form-password-input" placeholder={$_('settings.newPasswordPlaceholder')} />
                {/if}
            </div>

            {#if isTemporaryPassword}
            <div class="account-settings__form-password">
							<span on:click={() => {showNewPasswordRepeat = !showNewPasswordRepeat}} class={`account-settings__form-password-icon invisible`}>
								<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M2.05667 9.59073L1.36262 9.87499L2.05667 9.59073ZM2.75072 8.69352C3.75892 6.23184 6.1781 4.5 9 4.5V3C5.54839 3 2.59359 5.11944 1.36262 8.12501L2.75072 8.69352ZM9 4.5C11.8219 4.5 14.2411 6.23185 15.2493 8.69352L16.6374 8.12502C15.4064 5.11944 12.4516 3 9 3V4.5ZM15.2493 9.30648C14.2411 11.7682 11.8219 13.5 9 13.5V15C12.4516 15 15.4064 12.8806 16.6374 9.87499L15.2493 9.30648ZM9 13.5C6.1781 13.5 3.75892 11.7682 2.75071 9.30648L1.36262 9.87499C2.59358 12.8806 5.54839 15 9 15V13.5ZM15.2493 8.69352C15.3297 8.88978 15.3297 9.11022 15.2493 9.30648L16.6374 9.87499C16.867 9.31441 16.867 8.6856 16.6374 8.12502L15.2493 8.69352ZM1.36262 8.12501C1.13303 8.68559 1.13303 9.31441 1.36262 9.87499L2.75071 9.30648C2.67033 9.11022 2.67033 8.88978 2.75072 8.69352L1.36262 8.12501Z" fill="black" />
									<circle cx="9" cy="9" r="2.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							</span>
                <span on:click={() => {showNewPasswordRepeat = !showNewPasswordRepeat}} class={`account-settings__form-password-icon ${showNewPasswordRepeat ? '' : 'visible'}`}>
								<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M3 3L15 15" stroke="black" stroke-width="2" stroke-linecap="round" />
									<path fill-rule="evenodd" clip-rule="evenodd" d="M4.45176 4.36597C3.07891 5.27491 1.99401 6.58339 1.36262 8.12501C1.13303 8.68559 1.13303 9.31441 1.36262 9.87499C2.59358 12.8806 5.54839 15 9 15C10.7255 15 12.3269 14.4703 13.6508 13.565L12.5673 12.4815C11.532 13.1271 10.3094 13.5 9 13.5C6.1781 13.5 3.75892 11.7682 2.75071 9.30648C2.67033 9.11022 2.67033 8.88978 2.75071 8.69352C3.30705 7.33514 4.29303 6.19899 5.53922 5.45344L4.45176 4.36597ZM6.922 6.83622C6.35371 7.38212 6 8.14975 6 9C6 10.6569 7.34315 12 9 12C9.85025 12 10.6179 11.6463 11.1638 11.078L10.1027 10.0169C9.82862 10.314 9.43604 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.56396 7.68605 8.17138 7.9831 7.89731L6.922 6.83622ZM11.9988 9.08462L8.91538 6.00117C8.94349 6.00039 8.9717 6 9 6C10.6569 6 12 7.34315 12 9C12 9.0283 11.9996 9.05651 11.9988 9.08462ZM14.0937 11.1795C14.5746 10.6269 14.9672 9.99527 15.2493 9.30648C15.3297 9.11022 15.3297 8.88978 15.2493 8.69352C14.2411 6.23185 11.8219 4.5 9 4.5C8.50822 4.5 8.02868 4.5526 7.5667 4.65249L6.34928 3.43507C7.18113 3.153 8.07263 3 9 3C12.4516 3 15.4064 5.11944 16.6374 8.12502C16.867 8.6856 16.867 9.31441 16.6374 9.87499C16.2794 10.7491 15.7756 11.5482 15.1562 12.242L14.0937 11.1795Z" fill="black" />
								</svg>
							</span>

                {#if showNewPasswordRepeat}
                    <input bind:value={newPasswordRepeat} type="text" class="general-input account-settings__form-password-input" placeholder={$_('settings.newPasswordRepeatPlaceholder')} />
                {:else}
                    <input bind:value={newPasswordRepeat} type="password" class="general-input account-settings__form-password-input" placeholder={$_('settings.newPasswordRepeatPlaceholder')} />
                {/if}
            </div>

                <p class="account-settings__form-temp-text">{$_('settings.passwordChangeDescription')}</p>
            {/if}

            <button disabled={changeInfoLoading || (isTemporaryPassword && (!newPassword || !newPasswordRepeat || newPassword.length < 6 || newPasswordRepeat.length < 6))}
                    type="submit" class="button button_shadow account-settings__form-btn">
                <LoadingIcon show={changeInfoLoading} height="16" width="16" color="#fff" />
                {$_('settings.saveBtnLabel')}
            </button>

            {#if changeInfoError}
                <p class="account-settings__form-error">{changeInfoError}</p>
            {/if}
            {#if !changeInfoError && changeInfoSuccess}
                <p class="account-settings__form-success">{$_('settings.saveSuccessMessage')}</p>
            {/if}
        </form>
    </section>
</div>
<div class="canvas__col canvas__col_right">
    <section class="target-managment">
        <h4 class="target-managment__title">{$_('settings.targetsControlTitle')}</h4>
        <p class="target-managment__text">{$_('settings.targetsControlDescription')}</p>

        {#each analyzes as analyze}
            <SettingsAnalyzeInfo params={params} analyze={analyze} showDelete={false} isDeletable={isDeletable(analyze)} deletableDate={calcDeletionDate(new Date(analyze.date_start_epoch * 1000))} />
        {/each}
    </section>

    {#if window.language === 'ru-RU'}
    <section class="target-managment">
        <h4 class="target-managment__title">Управление своими аккаунтами</h4>
        <p class="target-managment__text">Здесь показаны ваши аккаунты, для слежки за приватными целями.</p>
        {#each handlers as handler}
            {#if handler.login !== undefined}
                <SettingsHandlerInfo handler={handler} bind:handlers bind:analyzes />
            {/if}
        {/each}
    </section>
    {/if}


    <section class="promocode-block">
        <h4 class="promocode-block__title">{$_('settings.promoCodeSettingsTitle')}</h4>
        <form action="" class="promocode-block__form" on:submit|preventDefault={initApplyPromo}>
            <input type="text" class="general-input promocode-block__input" placeholder={$_('settings.promoCodeInputPlaceholder')} bind:value={code} />
            <button disabled={promoInProgress || !code || code.length === 0} type="submit" class="button button_shadow promocode-block__btn">
                <LoadingIcon show={promoInProgress} height="16" width="16" color="#fff" />
                {$_('settings.activateBtnLabel')}
            </button>
            {#if promoError}
                <p class="promocode-block__status promocode-block__status_error">{promoError}</p>
            {/if}
            {#if promoSuccess}
                <p class="promocode-block__status promocode-block__status_success">
                    {promoSuccessMsg}
                </p>
            {/if}
        </form>
    </section>
</div>

<style>

</style>